import {BaseButton as PeacockBaseButton} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IBaseButtonProps} BaseButtonProps
 * @property {'default' | 'naked'} [type] Base button style type.
 * @property {boolean} [disabled] When true, button is disabled.
 * @property {'large' | 'medium' | 'small'} [size] Base button size.
 * @property {boolean} [isShowIcon] When true, renders icon.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [icon] Icon name or SVG props.
 * @property {boolean} [isShowDropdownIcon] When true, renders dropdown icon.
 * @property {boolean} [isShowLabel] When true, renders label.
 * @property {string} [label] Button label.
 * @property {import('@pepsico-ds/ui').ITooltipProps} [tooltip] Tooltip configuration.
 * @property {import('react').MouseEventHandler<HTMLButtonElement>} [onClick] Click handler.
 * @property {boolean} [active] Active state for icon button usage.
 * @property {boolean} [showSkeleton] Renders loading skeleton state.
 * @property {string} [containerClassName] Extra class name for wrapper/container.
 * @property {Omit<import('@pepsico-ds/ui').IBadgeProps, 'type'>} [badgeProps] Optional badge props.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS BaseButton.
 * Supports all Peacock DS base button props.
 * @param {BaseButtonProps} props
 */
export const BaseButton = props => {
  return <PeacockBaseButton {...props} />
}
